import React, {useState} from 'react';
import ValidationError from "~/Components/Forms/ValidationError";
import Translated from "~/Admin/AdminMultilang/Translated";

const AdminDietaryForm = ({values, errors, onChange, translated = true}) => {

    const defaultFields = {
        name: '',
        display_order: 0,
        translations: {}
    };

    const form = {...defaultFields, ...values};

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    return (
        <form>
            <div className="form-group">
                <label>Name</label>
                <Translated translations={form.translations}
                            enabled={translated}
                            onChanged={(values) => onChange({...form, translations: values})}>
                    <input
                        onChange={handleChange}
                        value={form.name}
                        name="name"
                        type="text"
                        className="form-control"/>

                </Translated>

                <ValidationError errors={errors} name="name" />
            </div>
            <div className="form-group">
                <label>Display Order</label>
                <input
                    onChange={handleChange}
                    value={form.display_order}
                    name="display_order"
                    type="text"
                    className="form-control"/>

                <ValidationError errors={errors} name="display_order" />
            </div>
        </form>
    );
}


export default AdminDietaryForm;
